import React, {PureComponent} from 'react'
import {Loading} from 'elements'

interface Props<T> {
  data: Array<T>
  level?: number
  loading?: boolean
  subTreeExtractor(item: T, index: number): Array<T> | undefined
  keyExtractor(item: T, index: number): string
  renderItem(item: T, level: number): JSX.Element
  onSelectItem?(item: T): void
}

class Tree<T> extends PureComponent<Props<T>, object> {
  static defaultProps = {
    level: 0
  }

  renderLeaf = (item, index) => {
    const {
      level,
      subTreeExtractor,
      keyExtractor,
      renderItem,
      onSelectItem
    } = this.props
    const handleSelectItem = onSelectItem || (() => {})
    const subTree = subTreeExtractor(item, index) || []
    const leaf = (
      <div
        key={keyExtractor(item, index)}
        onClick={() => handleSelectItem(item)}>
        {renderItem(item, level!)}
      </div>
    )

    if (subTree.length === 0) return leaf
    return (
      <div key={keyExtractor(item, index)}>
        {leaf}
        <Tree {...this.props} data={subTree} level={level! + 1} />
      </div>
    )
  }

  render() {
    const {data, loading} = this.props
    if (loading) return <Loading />
    return <div>{data.map((item, index) => this.renderLeaf(item, index))}</div>
  }
}

export default Tree



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tree.tsx